import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Locale } from '@core/enums/locale';
import { AppInitService } from '@core/services/app-init.service';
import { environment } from '@env';
import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';
import { getCulture } from '@shared/utils/locale-utils';

@Injectable({
  providedIn: 'root',
})
export class CookiebotConfigSerivce extends NgxCookiebotConfig {
  blockingMode: 'manual' = 'manual';
  cbId: string = environment.cookieBotId;
  cdn: 'com' | 'eu' | string = 'com';
  culture?: string;
  loadScript: boolean;

  constructor(appInitService: AppInitService, @Inject(LOCALE_ID) localeId: Locale) {
    super();
    this.loadScript = appInitService.Settings.ec.isCookieBotEnabled;
    this.culture = getCulture(localeId)?.substring(0, 2);
  }
}
